import { useDispatch, useSelector } from 'react-redux';

import {
  selectAppPreviousRoute,
  selectAppRoute,
  selectFidelityCardIdFromKiosk,
  selectIsDevToolsEnabled,
  selectIsFooterTutorialDisplayed,
  selectIsFunctionalityExplanationDisplayed,
  selectIsHostMocked,
  selectIsLocaleEditMode,
  selectIsSelectProductTooltipShown,
  selectIsSplashScreenPageShown,
  selectIsTasteIdGuideShown,
  selectIsTastePathOnboardingShown,
  selectIsTestResultView,
  selectIsThirdPartyConnectModalShown,
  selectLocale,
  selectServiceProductCategory,
  selectShouldHideDownloadAppCard,
  selectShouldShowScanBarcode,
  selectShouldShowTastePathStartPage,
  selectThirdPartyConnectModalScenario,
} from '@lib/core/service/selectors';
import { setServiceLocale, setSplashScreenPageShown } from '@lib/core/service/slices';
import { languages } from '@lib/tools/locale/utils/consts';

export const useApp = () => {
  const dispatch = useDispatch();

  const locale = useSelector(selectLocale);

  const handleSetServiceLocale = (languageCode: string) => {
    dispatch(setServiceLocale(languageCode));
  };

  const splashScreenPageShown = () => {
    dispatch(setSplashScreenPageShown());
  };

  const isLocaleRtl = () => {
    const rtlLanguages = [languages.ARABIC, languages.HEBREW];
    return rtlLanguages.some(language => locale.startsWith(language));
  };
  return {
    fidelityCardIdFromKiosk: useSelector(selectFidelityCardIdFromKiosk),
    handleSetServiceLocale,
    isDevToolsEnabled: useSelector(selectIsDevToolsEnabled),
    isFooterTutorialDisplayed: useSelector(selectIsFooterTutorialDisplayed),
    isFunctionalityExplanationDisplayed: useSelector(selectIsFunctionalityExplanationDisplayed),
    isHostMocked: useSelector(selectIsHostMocked),
    isLayoutRightToLeft: isLocaleRtl(),
    isLocaleEditMode: useSelector(selectIsLocaleEditMode),
    isSelectProductTooltipShown: useSelector(selectIsSelectProductTooltipShown),
    isSplashScreenPageShown: useSelector(selectIsSplashScreenPageShown),
    isTasteIdGuideShown: useSelector(selectIsTasteIdGuideShown),
    isTastePathOnboardingShown: useSelector(selectIsTastePathOnboardingShown),
    isTestResultView: useSelector(selectIsTestResultView),
    isThirdPartyConnectModalShown: useSelector(selectIsThirdPartyConnectModalShown),
    locale,
    previousRoute: useSelector(selectAppPreviousRoute),
    productCategory: useSelector(selectServiceProductCategory),
    route: useSelector(selectAppRoute),
    scenarioForThirdPartyConnectModalOpened: useSelector(selectThirdPartyConnectModalScenario),
    shouldHideDownloadAppCard: useSelector(selectShouldHideDownloadAppCard),
    shouldShowScanBarcode: useSelector(selectShouldShowScanBarcode),
    shouldShowTastePathStartPage: useSelector(selectShouldShowTastePathStartPage),
    splashScreenPageShown,
  };
};
